var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var NotificationVariant;
(function (NotificationVariant) {
    NotificationVariant["Success"] = "success";
    NotificationVariant["Error"] = "error";
})(NotificationVariant || (NotificationVariant = {}));
export var mapToNotificationsOptions = function (_a) {
    var isFailed = _a.isFailed, onFailed = _a.onFailed, onSuccess = _a.onSuccess;
    var _b = __read(isFailed
        ? [NotificationVariant.Error, onFailed()]
        : [NotificationVariant.Success, onSuccess()], 2), variant = _b[0], message = _b[1];
    return { variant: variant, message: message };
};
